import { Webhooks } from 'features/webhooks';

export const AdminWebhooksPage: React.FC = () => <Webhooks />;
